module.exports = __webpack_public_path__ + "media/images/pages/owner-27d4c55aa9a0d5f4d4625ac4c6be1b3b.png";